import { POST_CLASS_SUMMARY, UPDATE_SUBMISSION_SPREAD, POST_DRAFT_EVALUATION, POST_EVALUATION } from '../mutation-types';

import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
import { EventBus } from 'utils/event-bus';

// Summary
export const postClassSummary = ({ commit }, payload) => {
  commit(POST_CLASS_SUMMARY, payload);
};
export const postDraftEvaluation = ({ commit }, payload) => {
  const { submissionID } = payload;
  delete payload.submissionID;

  return roundtableService
    .submitDraftEvaluation(submissionID, payload)
    .then(({ data }) => {
      commit(POST_DRAFT_EVALUATION, {
        submissionID,
        draft_evaluation: data.draft_evaluation,
      });
      commit(UPDATE_SUBMISSION_SPREAD, { id: submissionID, draft_evaluation: data.draft_evaluation });
    })
    .catch((e) => {
      console.error(e);
      const msg = 'Message was not saved! Please refresh and try again.';
      EventBus.$emit('toast-msg', msg);
    });
};
export const postEvaluation = ({ commit, getters }, payload) => {
  const { submissionID, evaluation } = payload;
  delete payload.submissionID;
  if (getters.getCurrentRT.is_sandbox) {
    commit(POST_EVALUATION, { submissionID, evaluation });
    return null;
  }
  return roundtableService
    .submitEvaluation(submissionID, payload)
    .then(({ data }) => {
      commit(POST_EVALUATION, {
        submissionID: data.id,
        evaluation: data.evaluation,
      });
    })
    .catch((e) => {
      console.error(e);
      const msg = 'Message was not saved! Please refresh and try again.';
      EventBus.$emit('toast-msg', msg);
    });
};

export const selectAutomatedFeedback = (context, payload) => {
  return roundtableService.selectAutomatedFeedback(payload.submission_id, {
    tag: payload.tag,
  });
};

export const refreshAutomatedFeedback = (context, payload) => {
  return roundtableService.refreshAutomatedFeedback(payload.submission_id);
};

export const selectSavedFeedback = (context, payload) => {
  return roundtableService.selectSavedFeedback(payload.submission_id, {
    feedback_id: payload.feedback_id,
  });
};



// WEBPACK FOOTER //
// ./src/app/store/actions/grades.js